import styled from "styled-components";
import Divider from "../Divider";
import ContactsButton from "./ContactsButton";
import ContactFormOpen from "../../forms/ContactFormModal/ContactFormOpen";

export default function ContactDivider() {
  return (
    <ContactDividerStyled>
      <div className="divider">
        <Divider />
      </div>
      <ContactFormOpen isIncludeGeoData={false} />
      <ContactsButton text={"Calendly"} link={"https://calendly.com/martin-hofmann-hoze-solutions"} style="outline" />
    </ContactDividerStyled>
  );
}

const ContactDividerStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  margin: 30px 0 80px 0;

  .divider {
    flex: 1;
  }

  @media (max-width: 568px) {
    flex-direction: column;
    .divider {
      display: none;
    }
  }
`;
